import React from 'react';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
interface ConversationItemProps {
  id: string;
  name: string;
  handle: string;
  avatar: string;
  lastMessage: string;
  timestamp: string;
  unreadCount: number;
  isOnline: boolean;
  isActive: boolean;
  onClick: () => void;
}
export function ConversationItem({
  name,
  handle,
  avatar,
  lastMessage,
  timestamp,
  unreadCount,
  isOnline,
  isActive,
  onClick
}: ConversationItemProps) {
  return <div onClick={onClick} className={`flex items-center p-3 cursor-pointer transition-colors hover:bg-accent/50 ${isActive ? 'bg-accent' : ''}`} data-id="element-97">
      <Avatar src={avatar} alt={name} isOnline={isOnline} size="md" data-id="element-98" />
      <div className="ml-3 flex-1 overflow-hidden" data-id="element-99">
        <div className="flex justify-between items-baseline" data-id="element-100">
          <h4 className={`text-sm font-semibold truncate ${isActive ? 'text-accent-foreground' : 'text-foreground'}`} data-id="element-101">
            {name}
          </h4>
          <span className="text-[10px] text-muted-foreground ml-2 whitespace-nowrap" data-id="element-102">
            {timestamp}
          </span>
        </div>
        <div className="flex justify-between items-center mt-0.5" data-id="element-103">
          <p className="text-xs text-muted-foreground truncate pr-2" data-id="element-104">
            {lastMessage}
          </p>
          {unreadCount > 0 && <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-600 text-[10px] font-medium text-white" data-id="element-105">
              {unreadCount}
            </span>}
        </div>
      </div>
    </div>;
}